// Saved dashboards (WS-D D5) — the client half.
//
// A board is the user's placed modules persisted server-side under their
// account (app-api `/boards/{id}`, auth: jwt). The demo uses a single id
// `default`, saved on the Save button and auto-loaded on sign-in. `modules` is
// the store's `BentoModule[]` round-tripped as-is (the backend treats it as
// opaque JSON — the frontend owns the shape).

import type { BentoModule } from "../store/module.js";
import { apiGet, apiSend } from "./api.js";

/** The single board id the demo reads/writes. Board-keyed on the backend so
 *  multiple boards later is a frontend-only change (see first-demo-plan §7). */
export const DEFAULT_BOARD_ID = "default";

export interface Board {
  userId: string;
  boardId: string;
  name: string;
  savedOnMobile: boolean;
  modules: BentoModule[];
  updatedAt: string;
}

/** Read the caller's board. Rejects with `ApiError` (status 404 = none saved). */
export function loadBoard(boardId: string = DEFAULT_BOARD_ID): Promise<Board> {
  return apiGet<Board>(`/boards/${boardId}`);
}

/** Upsert the caller's board. `savedOnMobile` lets the loader reflow a
 *  mobile-saved board onto the desktop grid (CLAUDE.md "Saved boards"). */
export function saveBoard(
  board: { modules: BentoModule[]; savedOnMobile: boolean; name?: string },
  boardId: string = DEFAULT_BOARD_ID
): Promise<Board> {
  return apiSend<Board>("PUT", `/boards/${boardId}`, {
    name: board.name ?? "My board",
    savedOnMobile: board.savedOnMobile,
    modules: board.modules,
  });
}
